import { render, staticRenderFns } from "./view-post.vue?vue&type=template&id=c446519c&"
import script from "./view-post.vue?vue&type=script&lang=js&"
export * from "./view-post.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports